module.exports = __webpack_public_path__ + "static/media/añadir_titulo_off.4841d0a1.png";